/**
 * @generated SignedSource<<1c6387c3ead8cdcd65a8b84d53f56cdf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceLinks_spaceSidebarLinks$data = {
  readonly main: ReadonlyArray<{
    readonly hidden: boolean;
    readonly id: string;
    readonly position: number;
    readonly webItemCompleteKey: string | null;
  } | null> | null;
  readonly " $fragmentType": "SpaceLinks_spaceSidebarLinks";
};
export type SpaceLinks_spaceSidebarLinks$key = {
  readonly " $data"?: SpaceLinks_spaceSidebarLinks$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceLinks_spaceSidebarLinks">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceLinks_spaceSidebarLinks",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "includeHidden",
          "value": true
        }
      ],
      "concreteType": "SpaceSidebarLink",
      "kind": "LinkedField",
      "name": "main",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "webItemCompleteKey"
        },
        {
          "kind": "ScalarField",
          "name": "position"
        },
        {
          "kind": "ScalarField",
          "name": "hidden"
        }
      ],
      "storageKey": "main(includeHidden:true)"
    }
  ],
  "type": "SpaceSidebarLinks"
};

(node as any).hash = "26e483dae4ed854796f11e515ee4e767";

export default node;
